import { render } from "./SkillsSelector.vue?vue&type=template&id=20b80627"
import script from "./SkillsSelector.vue?vue&type=script&lang=js"
export * from "./SkillsSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__